import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  processingTitle: {
    id: 'course-authoring.studio-home.processing.title',
    defaultMessage: 'Courses being processed',
  },
});

export default messages;
